<template>
  <section class="pa-20 has-background-white">
    <p class="has-text-weight-bold is-size-6 has-text-grid-1 mb-20">
      {{ titreAffiche }}
    </p>
    <MsgError
      v-if="isError"
      type="is-danger"
      :msg="msgError"
      @close="msgErrorClose"/>
    <div>
      <div class="columns is-marginless">
        <div class="column is-1 px-0">
          <button class="button is-primary is-size-14px has-text-weight-bold destinataire">
            {{$t('envoiMail.destinataire')}}
          </button>
        </div>
        <div class="column px-0">
          <b-field :type="isDestinataireError ? 'is-danger' : 'is-primary'">
            <b-taginput
              type="is-primary" expanded
              v-model="mail.To">
            </b-taginput>
          </b-field>
        </div>
        <div class="column is-1 destinataire px-0">
          <button class="button has-text-default is-size-7
              destinataire no-border pl-10"
              @click="isCc = true">
              {{$t('envoiMail.titleCC')}}
          </button>
        </div>
      </div>
      <div class="columns is-marginless" v-if="isCc">
        <div class="column is-1 px-0">
          <button class="button is-size-14px destinataire has-text-default" @click="isCc = false">
            {{$t('envoiMail.titleCC')}}
          </button>
        </div>
        <div class="column px-0">
          <b-field>
            <b-taginput
              type="is-primary" expanded
              v-model="mail.Cc">
            </b-taginput>
          </b-field>
        </div>
      </div>
      <div class="columns is-marginless">
        <div class="column is-1 px-0">
          <button class="button is-size-14px destinataire has-text-default">
            {{$t('envoiMail.titleCci')}}
          </button>
        </div>
        <div class="column px-0">
          <b-field>
            <b-taginput
              type="is-primary" expanded
              v-model="mail.Cci">
            </b-taginput>
          </b-field>
        </div>
      </div>
      <div class="columns is-marginless">
        <div class="column is-1 px-0">
          <button class="button is-size-14px destinataire has-text-default">
            {{$t('envoiMail.titleReplyTo')}}
          </button>
        </div>
        <div class="column px-0">
          <b-field :type="isReplyToError ? 'is-danger' : 'is-primary'">
            <b-input type="email"
                    :placeholder="$t('envoiMail.titleReplyTo')" v-model="mail.replyTo">
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="field mb-20">
        <p class="control">
          <input class="input"
                type="text"
                :placeholder="$t('envoiMail.placeholderObjet')"
                v-model="mail.Objet">
        </p>
      </div>
      <b-field :type="isCorpsMailError ? 'is-danger' : ''">
        <b-input type="textarea"
                :placeholder="$t('envoiMail.placeholderMessage')" v-model="mail.Corps">
        </b-input>
      </b-field>
      <div class="level mt-30">
        <div class="level-left">
          <p class="is-size-14px has-text-grid-1 has-text-weight-bold">
              {{$t('envoiMail.piecesJointes')}}
            </p>
        </div>
        <div class="level-right">
          <b-field class="file">
            <b-upload multiple v-model="pJointes" @input="addPJ">
                <a class="button is-primary has-text-weight-bold">
                  <span>{{$t('envoiMail.btnAjoutPJ')}}</span>
                </a>
            </b-upload>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-6" v-for="(objectFile, index) in allFichier" :key="index">
            <div class="media media-align-center piecejointe"
                :class="{
                  'affichageColor': objectFile.status,
                  'masquerColor': !objectFile.status,
                  }">
              <figure class="media-left ml-10">
                <p class="image">
                  <img class="picto-file-mail" :src="getImgPictoFile(objectFile.file.name)">
                </p>
              </figure>
              <div class="media-content">
                <div class="content width-file-name">
                  <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0 truncate-file-name">
                    {{objectFile.file.name}}
                  </p>
                  <p class="is-size-7 has-text-default">
                    {{formatDate(objectFile.file.lastModifiedDate)}} - {{objectFile.file.size}} Ko
                  </p>
                </div>
              </div>
              <div class="media-right">
                <b-dropdown
                  position="is-bottom-left"
                  aria-role="list">
                  <a
                    class="navbar-item"
                    slot="trigger"
                    role="button">
                    <b-icon custom-class="icon-color" icon="dots-vertical"></b-icon>
                  </a>
                  <b-dropdown-item
                    aria-role="menuitem"
                    @click="objectFile.status = !objectFile.status"
                    v-if="objectFile.type === 'isUpload'">
                    {{objectFile.status ? $t('envoiMail.masquerDansEmail') : $t('envoiMail.afficherDansEmail')}}
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="menuitem"
                    @click="deletePJointes(index)"
                    v-else>
                    {{$t('envoiMail.supprimerDansEmail')}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="level mt-30">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <button class="button is-transparent has-text-default"
            @click="$emit('change-send', !isSend)">
            {{$t('envoiMail.btnAnnuler')}}
          </button>
        </div>
        <div class="level-item">
          <button class="button is-primary has-text-weight-bold"
            @click="envoyerMail">
            {{$t('envoiMail.btnValider')}}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import envoiMail from '@/services/general/envoiMail';
import toastConfirmation from '@/services/general/toastConfirmation'
import { createNamespacedHelpers } from 'vuex';
import MsgError from '@/components/general/messageErreur';
import { getImgPictoFile } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import moment from 'moment';


const User = createNamespacedHelpers('user');

export default {
  components: {
    MsgError,
  },
  props: {
    isSend: Boolean,
    idRecom: String,
    recomPdf: Array,
    societeId: {
      type: String,
      required: false,
    },
    mettreEdition: {
      type: Boolean,
      required: false,
      default: false,
    },
emailDestinataire: {
    type: String,
    required: false,
    default: '',
  },
  objetEmail: {
    type: String,
    required: false,
    default: '',
  },
  titreModal: {
    type: String,
    required: false,
    default: '',
  },
  },
  data() {
    return {
      mail: {
        To: [],
        Cc: [],
        Cci: [],
        replyTo: null,
        Objet: null,
        Corps: '',
      },
      isCc: false,
      isCci: false,
      objetDefault: 'Notre recommandation',
      isError: false,
      msgError: '',
      isDestinataireError: false,
      isCorpsMailError: false,
      isReplyToError: false,
      pJointes: [],
      allFichier: [],
    };
  },
  computed: {
    ...User.mapGetters({
      userEmail: 'userEmail',
    }),
	titreAffiche() {
      return this.titreModal || this.$t('envoiMail.titreEnvoiMail');
    }
  },
  methods: {
    msgErrorClose() {
      this.isDestinataireError = false;
      this.isCorpsMailError = false;
      this.isError = false;
      this.isReplyToError = false;
    },
    showMsgError(msg) {
      this.msgError = msg;
      this.isError = true;
    },
    formatDate(date) {
      return moment(date).format('LL');
    },
    getImgPictoFile(name) {
      const split = name.split('.');
      const type = split[split.length - 1];
      return getImgPictoFile(type)
    },
    addPJ(files) {
      files.forEach(el => {
        this.allFichier.push({
          file: el,
          type: 'isAdd',
          status: true,
        });
      });
      this.pJointes = [];
    },
    controleChamp() {
      if (this.mail.To.length === 0) this.isDestinataireError = true;
      else this.isDestinataireError = false;
      if (this.mail.Corps.length === 0) this.isCorpsMailError = true;
      else this.isCorpsMailError = false;
      if (!this.mail.replyTo) this.isReplyToError = true;
      else this.isReplyToError = false;
      return this.isReplyToError ||this.isDestinataireError || this.isCorpsMailError;
    },
    async envoyerMail() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        if (this.controleChamp()) {
          this.showMsgError(this.$t('envoiMail.messageErreur'));
          loadingComponent.close();
          return false;
        }
        if (this.mail.To.length > 0 && this.mail.Cci.length > 0) {
          const isCciSameToTo = this.mail.To.filter((item) => {
            return this.mail.Cci.filter(c => {
              return c === item;
            }).length > 0;
          }).length > 0;
          if (isCciSameToTo) {
            this.showMsgError(this.$t('envoiMail.messageErreurCciToIdentiques'));
            loadingComponent.close();
            return false;
          }
        }
        const payload = {
          mail: this.mail,
          pJointes: this.allFichier.filter(el => el.status).map(el => el.file),
          elementId: this.idRecom,
          societeId: this.societeId,
          mettreEdition: this.mettreEdition,
        };      
        if (await envoiMail(loadingComponent, payload)) {
          this.viderChamp();
          loadingComponent.close();
        }
        loadingComponent.close();
      } catch (error) {
        gestionErreur(`Erreur lors de l'envoi de mail`, error);
        loadingComponent.close();
        throw error;
      }
    },
    deletePJointes(index) {
      this.allFichier.splice(index, 1);
    },
    viderChamp() {
      this.mail = {};
      this.allFichier = [];
      toastConfirmation(this.$t('envoiMail.messageConfirmation'))
      this.$emit('change-send', !this.isSend);
    }
  },
  mounted() {
    this.mail.Objet = this.objetEmail || this.objetDefault;
    if (this.userEmail) {
      this.mail.Cci.push(this.userEmail);
      this.mail.replyTo = this.userEmail;
    }
	if (this.emailDestinataire) {
    this.mail.To.push(this.emailDestinataire);
  }
    this.recomPdf.forEach(el => {
      this.allFichier.push({
        file: el,
        type: 'isUpload',
        status: true,
      })
    })
  },
};
</script>

<style>
  .textarea:not([rows]) {
    max-height: 600px;
    min-height: 280px !important;
  }
</style>